const loader = document.getElementById("loader-overlay");
const backToTop = document.getElementById("back-to-top");

window.addEventListener("DOMContentLoaded", function() {
    if (loader) loader.style.display = "none";
})

window.addEventListener("scroll", function() {
    if (!backToTop) return;
    if (this.window.scrollY > 300) {
        backToTop.style.display = "block";
    } else {
        backToTop.style.display = "none";
    }
});

if (backToTop) {
    backToTop.addEventListener("click", function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    });
}

if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(".reveal").forEach(function(el) {
        el.classList.add("reveal-visible");
    });
} else if ("IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("reveal-visible");
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: "0px 0px -40px 0px",
        threshold: 0
    });

    document.querySelectorAll(".reveal").forEach(function(el) {
        revealObserver.observe(el);
    });

    // A ratio-based threshold can never be met by a target taller than
    // (root height / threshold), so threshold must stay at 0 to keep long
    // articles visible. Separately, anything already scrolled past the viewport
    // can no longer intersect, so reveal it directly instead of leaving it
    // stuck at opacity 0 until the user scrolls back up past it.
    const revealScrolledPast = function() {
        document.querySelectorAll(".reveal:not(.reveal-visible)").forEach(function(el) {
            if (el.getBoundingClientRect().bottom < 0) {
                el.classList.add("reveal-visible");
                revealObserver.unobserve(el);
            }
        });
    };

    revealScrolledPast();
    window.addEventListener("scroll", revealScrolledPast, { passive: true });
} else {
    document.querySelectorAll(".reveal").forEach(function(el) {
        el.classList.add("reveal-visible");
    });
}

const navbar = document.getElementById("navbar");
const navToggle = document.getElementById("nav-toggle");

if (navbar && navToggle) {
    const navToggleIcon = document.getElementById("nav-toggle-icon");
    const navBackdrop = document.getElementById("navbar-backdrop");
    const navPanel = document.getElementById("navbar-panel");
    const navPanelLink = navPanel ? navPanel.querySelector("a") : null;
    const desktopQuery = window.matchMedia("(min-width: 768px)");

    // Reserve the scrollbar gutter while the panel is open so the page
    // behind it does not shift sideways on browsers with classic scrollbars.
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    const setNavOpen = function(open) {
        const wasOpen = document.body.classList.contains("nav-open");
        if (open === wasOpen) {
            return;
        }

        /* Tracked on <body>: the panel and backdrop are siblings of the
           navbar, so the CSS open-state selector needs a common ancestor. */
        document.body.classList.toggle("nav-open", open);
        navToggle.setAttribute("aria-expanded", open ? "true" : "false");
        navToggle.setAttribute("aria-label", open ? "Close navigation" : "Open navigation");
        document.body.style.overflow = open ? "hidden" : "";
        document.body.style.paddingRight = open && scrollbarWidth > 0 ? scrollbarWidth + "px" : "";

        if (navToggleIcon) {
            navToggleIcon.classList.toggle("fa-bars", !open);
            navToggleIcon.classList.toggle("fa-times", open);
        }

        if (navPanel) {
            navPanel.setAttribute("aria-hidden", open ? "false" : "true");
        }

        if (open && navPanelLink) {
            // visibility flips with no transition on open, so this lands.
            navPanelLink.focus();
        } else if (wasOpen) {
            // Only pull focus back if the panel was the thing that closed.
            navToggle.focus();
        }
    };

    navToggle.addEventListener("click", function() {
        setNavOpen(!document.body.classList.contains("nav-open"));
    });

    if (navBackdrop) {
        navBackdrop.addEventListener("click", function() {
            setNavOpen(false);
        });
    }

    if (navPanel) {
        navPanel.querySelectorAll("a").forEach(function(link) {
            link.addEventListener("click", function() {
                setNavOpen(false);
            });
        });
    }

    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && document.body.classList.contains("nav-open")) {
            setNavOpen(false);
        }
    });

    // The offcanvas only exists below md; leaving it open would pin the
    // scroll lock once the inline desktop menu takes over.
    const onBreakpointChange = function(e) {
        if (e.matches) {
            setNavOpen(false);
        }
    };

    if (typeof desktopQuery.addEventListener === "function") {
        desktopQuery.addEventListener("change", onBreakpointChange);
    } else if (typeof desktopQuery.addListener === "function") {
        desktopQuery.addListener(onBreakpointChange);
    }
}

const copyBtn = document.getElementById("copyBtn");
const copyLabel = document.getElementById("copyLabel");

if (copyBtn && copyLabel) {
    copyBtn.addEventListener("click", function() {
        const copyText = function() {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                return navigator.clipboard.writeText(window.location.href);
            }
            const textarea = document.createElement("textarea");
            textarea.value = window.location.href;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            return Promise.resolve();
        };

        copyText().then(function() {
            copyLabel.textContent = "Copied!";
            copyBtn.classList.add("copied");
            window.setTimeout(function() {
                copyLabel.textContent = "Copy link";
                copyBtn.classList.remove("copied");
            }, 2000);
        });
    });
}